// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_login_login_module_ts":"d2e79a7f1d3ed618","src_app_logistic_logistic_module_ts":"4f3b6e7e3d541528"}[chunkId] + ".js";
};